<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
        <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
            <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-end py-2" v-if="!preview">
                    <v-btn @click="convertPlaceholders(measures.items)" color="primary">Riempimento automatico</v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-simple-table class="measure_table">
                <template v-slot:default>
                    <thead class="expansion">
                    <tr>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.addLoad}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.p}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.error}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mpe}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.result}}</th>
                    </tr>
                    </thead>
                    <tr v-for="(item,index) of measures.items" :key="index">
                        <td class="table-blocks text-left">
                            <NumericField dense outlined
                            solo hide-details
                            :readonly="preview"
                            v-model="item.mass"
                            :precision="currentPrecision"
                            :negative="false"
                            :class="readingWarning(item.mass)"
                            @input="changeMass(item)" 
                            ></NumericField>
                        </td>
                        <td class="table-blocks text-left">
                            <NumericField dense outlined
                            solo hide-details
                            :readonly="preview"
                            v-model="item.reading"
                            :precision="currentPrecision"
                            :negative="false"
                            :class="readingWarning(item.reading)"
                            @input="changeZeroReading(item)" 
                            :placeholder="readingPlaceholder(item.mass)"
                            :enableicons="!preview"
                            :addfunc="readingAddFunc"
                            :subfunc="readingSubFunc"
                            :row="item"
                            :fieldname="'reading'"
                            :range="calcMinRange(item.reading)"
                            ></NumericField>
                            </td>
                        <td class="table-blocks text-left">
                             <NumericField dense outlined
                            solo hide-details
                            class="text-left"
                            :readonly="preview"
                            v-model="item.addLoad"
                            :precision="high_precision"
                            :negative="false"
                            @input="changeZeroAddLoad(item)"
                            :placeholder="calculateAddLoadPlaceholder(item.reading)"
                            :class="addLoadWarning(item.addLoad, item.reading)"
                            :enableicons="!preview"
                            :addfunc="loadAddFunc"
                            :subfunc="loadSubFunc"
                            :row="item"
                            :fieldname="'addLoad'"
                            :range="calcMinRange(item.reading)"
                            ></NumericField>
                        </td>
                        <td class="text-right table-text-blocks"><b>{{item.p | formatNumber}}</b></td>
                        <td class="text-right table-text-blocks"><b>{{item.error | formatNumber}}</b></td>
                        <td class="text-right table-text-blocks"><b>{{item.mpe | formatNumber}}</b></td>
                        <td class="text-right table-text-blocks">
                            <StatusIcon :status="item.result" :tooltip_text="row_tooltip[item.result]"/>
                        </td>
                    </tr>
                </template>           
            </v-simple-table>
            </v-row>
            <v-row no-gutters>
                <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div v-if="precision_overflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                    <div v-if="addLoad_overflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla carico addizionale</b></div>
                </div>
            </v-row>
            </v-container>
        </div>
    </LayoutBlock>
</template>

<script>
import { zero_accuracy_item } from '../../../utils/itemBlockSchema';
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from '../../../components/utils/StatusIcon'
import {BaseLeg} from "../../../utils/baseLeg"
import Big from "big.js"

export default {
    components: {LayoutBlock, StatusIcon},
    mixins: [BaseLeg],
  
    methods: {
        async buildMeasures() {
            this.measures = {
                hi_res: "off",
                items: [],
                result: 'uncomplete'
            }
            let catval = await this.buildWithCategory()
            if(catval){
                for (let i = 1 ; i <= this.conf.min_readings ; i++){
                    let item = zero_accuracy_item({
                        mass: catval
                    })
                this.measures.items.push(item)
                this.changeMass(item)
                }

            } else {
                for (let i = 1 ; i <= this.conf.min_readings ; i++){
                    let item = zero_accuracy_item({})
                this.measures.items.push(item)
                this.changeMass(item)
                }
            }
            // console.log("DEBUG items", this.measures)
            
        },
        changeMass(row){
            this.changeReading(row)
            if(row.mass){
                let temp = Big(this.calc_MPE(this.calcMinRange(row.mass), row.mass))
                row.mpe = temp.times(0.25).toString()
                this.calculateError(row)
            }
        },
        changeZeroReading(row){
            this.changeReading(row)
            this.calculateError(row)
        },
        changeZeroAddLoad(row){
            this.changeAddLoad(row)
            this.calculateError(row)
        },
        calculateError(row){
            if(row.reading != "" && row.reading != null && row.addLoad != "" && row.addLoad != null){
                if(row.p && row.mass && !this.addLoad_overflow){
                    row.error = this.round(Big(row.p).minus(row.mass), this.high_precision)
                    this.calculateResult(row)
                } else {
                    row.result = "failed"
                }
            } else {
                row.result = "uncomplete"
            }
        },
        calculateResult(row) {
            let res = this.checkReading(row.reading)
            switch (res) {
                case 'uncomplete':
                    this.$set(row, 'result', 'uncomplete')
                    break
                case 'failed':
                    this.$set(row, 'result', 'failed')
                    break
                case 'done':
                    this.$set(row, 'result', Big(row.mpe).gte(Math.abs(row.error)) ? 'done' : 'failed')
                    break
            }
        },
        
      
    },
    
}
</script>

<style>

</style>
